<template>
  <div class="selectSignContainer">
    <breadcrumb>
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: `/personal/serviceHome?flag=third` }">律师服务</el-breadcrumb-item>
        <el-breadcrumb-item>查看证书</el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
    <div class="tabContainerSign">
      <div class="moreSign" v-if="showMoreBtn">
        <div class="selectMore">查看更多</div>
        <div class="allSignContainer">
          <ul class="allSign">
            <li
              class="allSignItem ellipsis"
              v-for="(item,index) in fileArray"
              :key="index"
              @click="changeShowTab(item)"
            >{{item.fileName}}</li>
          </ul>
        </div>
      </div>

      <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
        <el-tab-pane
          v-for="(item,index) in fileArray"
          :key="index"
          :label="item.fileName"
          :name="item.id"
          :url="item.filePath"
          :item="item"
        >
          <div class="showAreaContent">
            <div class="handlerBar">
              <span class="handlerBtn" @click="toVoucher">查看合同详细凭证</span>
              <span class="handlerBtn" @click="toSelectSign">合同预览</span>
              <span class="handlerBtn" @click="downLoad">下载</span>
            </div>
            <div class="pdfCon">
              <div class="pdfShowArea" :id="item.id"></div>
            </div>
            <div class="certificateBox">
              <see :data="seeData" v-if="seeData"></see>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "../../../../../components/common/Breadcrumb.vue";
// import PDFJS from "pdfjs-dist";
import browser from "@lib/getBrowser.js";
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util.js";
import see from "@common/see.vue";
export default {
  data() {
    return {
      activeName: "",
      currentItem: null,
      fileArray: [],
      showMoreBtn: false,
      seeData: null
    };
  },
  components: {
    Breadcrumb,
    see
  },
  mounted() {
    this.getFiled();
    $(window).resize(() =>
      // 绑定到窗口的这个事件中
      {
        this.judgeMoreShow();
      }
    );
  },
  methods: {
    changeShowTab(item) {
      console.log("来源ip360");
      this.activeName = item.id;
      this.activeChange("", item);
    },
    toVoucher() {
      this.$router.push(`/personal/sign/voucher?id=${this.$route.query.id}`);
    },
    downLoad() {
      BaseApi.createRpcToken("/file/download", {
        id: this.$route.query.id
      })
        .then(data => {
          if (data.datas.zipUrl) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              document.body.appendChild(elemIF);
            } catch (e) {}
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    toSelectSign() {
      this.$router.push(`/personal/sign/selectSign?id=${this.$route.query.id}`);
    },
    getCrea(fileId) {
      this.seeData = null;
      BaseApi.createRpcToken("/file/cert", {
        fileId: fileId || 1
      })
        .then(
          data => {
            this.seeData = data.datas.cert;
          },
          () => {
            let data = {
              code: 200,
              datas: {
                cert: {
                  fileName: "测试证据",
                  contractUser: {
                    enterpriseStatus: 2,
                    name: "淡绿鱼米之乡公司",
                    realNameType: 2,
                    userId: 1703
                  },
                  contract: {
                    signStartTime: "2019-01-08 10:39:31",
                    orderType: 0,
                    code: "0120190108000138",
                    endDate: "2019-12-30 00:00:00",
                    signStatus: 2,
                    signUserCount: 0,
                    userId: 1703,
                    name: "鱼塘承包合同5",
                    signDeadlineDate: "2019-01-25 00:00:00",
                    payStatus: 1,
                    startDate: "2019-01-22 00:00:00"
                  },
                  signatoryList: [
                    {
                      name: "刘火火",
                      realNameType: 1,
                      realNameStatus: 2,
                      userId: 1
                    },
                    {
                      enterpriseStatus: 2,
                      name: "一个公司",
                      realNameType: 2,
                      userId: 3
                    },
                    {
                      name: "郭帅勋",
                      realNameType: 1,
                      realNameStatus: 2,
                      userId: 1163
                    }
                  ],
                  fileId: "cfb7e925adc24711ba452898bea8fb92"
                }
              },
              message: "Success"
            };
            this.seeData = data.datas.cert;
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    getFiled() {
      BaseApi.createRpcToken("/file/list", {
        id: this.$route.query.id || "b70a942ada294030b8037ed556f57dd1"
      })
        .then(
          data => {
            this.fileArray = data.datas.list;
            this.activeChange("", this.fileArray[0]);
            this.judgeMoreShow();
          },
          () => {
            this.activeChange("", this.fileArray[0]);
            this.judgeMoreShow();
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeMoreShow() {
      let interValFlag = setInterval(() => {
        if ($(".el-tabs__nav-wrap").width()) {
          clearInterval(interValFlag);
          if ($(".el-tabs__nav-next")[0]) {
            this.showMoreBtn = true;
          } else {
            this.showMoreBtn = false;
          }
        }
      }, 10);
    },
    toTop(id) {
      $(`#${id}`).scrollTop(0);
    },
    toBottom(id) {
      $(`#${id}`).scrollTop($(`#${id}`)[0].scrollHeight);
    },
    activeChange(node, item) {
      this.currentItem = (node && node.$attrs.item) || item;
      this.activeName = this.currentItem.id;
      this.$nextTick(() => {
        this.getPdfToImage(this.currentItem.filePath, this.currentItem.id);
        this.getCrea(this.currentItem.id);
      });
    },
    getPage(page, index, id) {
      var canvasContainerWidth = 430;
      var scale = 1; //缩放倍数，1表示原始大小
      var viewport = page.getViewport(scale);
      viewport = page.getViewport(canvasContainerWidth / viewport.width);
      var canvas = document.getElementById("canvas" + index + id);
      var canvasFather = canvas.parentNode;
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvasFather.style.width = viewport.width + "px";
      canvasFather.style.height = viewport.height + "px";
      canvasFather.style.marginBottom = "10px";
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      page.render(renderContext).promise.then(() => {
        this.loadedPageCount++;
      });
    },
    getPdfToImage(url, id) {
      let container = document.getElementById(id);
      container.style.display = "block";
      let _this = this;
      url =
        url ||
        "http://xcon-dev.oss-cn-beijing.aliyuncs.com/contract/1703/20181228/b7cc408b4dde4810bbbb7cb51d46e342.pdf";
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.totalPage = pdf.numPages;
        for (let i = 1; i <= _this.totalPage; i++) {
          $(container).append(
            `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas><p class="pdfPageFlag">${i}/${
              _this.totalPage
            }</div>`
          );
          pdf.getPage(i).then(page => {
            _this.getPage(page, i, id);
          });
        }
        $(".canvasBoxFlag").addClass("canvasBox");
        $(".pdfPageFlag").addClass("pdfPage");
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scope>
.selectSignContainer {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  .tabContainerSign {
    height: calc(100% - 40px);
    box-sizing: border-box;
    padding-top: 20px;
    position: relative;
    .el-tabs__header {
      max-width: calc(100% - 120px);
    }
    .moreSign {
      &:hover {
        .allSignContainer {
          display: block;
        }
      }
    }
    .allSignContainer {
      display: none;
      position: absolute;
      top: 53px;
      z-index: 10;
      width: 100%;
      .allSign {
        opacity: 0.8;
        background: #ffffff;
        border: 1px solid #e4e8eb;
        padding-top: 10px;
        .allSignItem {
          display: inline-block;
          cursor: pointer;
          width: 132px;
          font-size: 12px;
          line-height: 32px;
          padding: 0 20px;
          &:hover {
            color: #e88078;
          }
        }
      }
    }
    .selectMore {
      position: absolute;
      cursor: pointer;
      width: 100px;
      height: 30px;
      line-height: 32px;
      right: 0;
      top: 20px;
      border: 1px solid #e29999;
      font-size: 12px;
      color: #e29999;
      text-align: center;
      z-index: 2;
    }
    .el-tabs {
      height: 100%;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 33px;
    }
    .el-tabs__item {
      height: 33px;
      line-height: 30px;
      font-size: 12px;
      color: #646464;
      background: #f5f5f5;
      border-top: 3px solid #f5f5f5;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item:hover {
      color: #e88078;
    }
    .el-tabs--card > .el-tabs__header {
      border-bottom: 1px solid #e4e8eb;
    }
    .el-tabs__item.is-active {
      color: #e88078;
      background-color: #ffffff;
      border-top: 3px solid #e88078;
    }
    .canvasBox {
      position: relative;
      canvas {
        // border-radius: 18px;
      }
    }
    .page {
      position: position;
      right: 50px;
      width: 60px;
      text-align: center;
      bottom: 81px;
      z-index: 20;
      span {
        margin-top: 6px;
        display: block;
      }
      .up {
        img {
          margin: 0 auto;
        }
        .nor {
          display: block;
        }
        .hov {
          display: none;
        }
        &:hover {
          .nor {
            display: none;
          }
          .hov {
            display: block;
          }
        }
      }
    }
    .pdfPage {
      position: absolute;
      top: 24px;
      right: 24px;
      padding: 3px 16px;
      font-size: 18px;
      font-weight: 200;
      color: #fff;
      line-height: 25px;
      border-radius: 8px;
      background: #9b9b9b;
    }
    .el-tabs__content {
      box-sizing: border-box;
      border: 1px solid #e4e8eb;
      border-top: none;
      padding: 10px;
      height: calc(100% - 48px);
      background: #e3e9ef;
      // overflow: auto;
      width: 100%;
      position: relative;
      .el-tab-pane {
        height: 100%;
        // display: flex;
        // justify-content: center;
        text-align: center;
        .showAreaContent {
          width: 1010px;
          margin: 0 auto;
          height: 100%;
          overflow: auto;
          .handlerBar {
            height: 72px;
            box-sizing: border-box;
            padding-top: 20.5px;
            text-align: right;
            .handlerBtn {
              display: inline-block;
              margin-right: 10px;
              height: 32px;
              line-height: 32px;
              border: 1px solid #c8c8c8;
              cursor: pointer;
              font-size: 12px;
              color: #646464;
              padding: 0 26px;
            }
          }
          .pdfCon {
            float: left;
            position: relative;
            box-sizing: border-box;
            height: calc(100% - 90px);
            width: 500px;
            padding: 30px;
            background: #eaedf1;
            overflow: auto;
            border: 1px solid #dcdcdc;
          }
          .certificateBox {
            width: 440px;
            float: right;
            height: calc(100% - 110px);
            overflow: auto;
            box-shadow: 0 6px 8px 0 rgba(220, 220, 220, 0.5);
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>
